import {z as zod} from "zod";

export type CustomerAuthenticationOtpSmsDeliveryConfiguration = {
    apiUrl: string;
    from: string;
    messageTemplate: string;
    password: string;
    smsType: string;
    templateId: string;
    username: string;
};

export type CustomerAuthenticationOtpDeliveryConfiguration = {
    sms: CustomerAuthenticationOtpSmsDeliveryConfiguration;
};

export type CustomerAuthenticationWorkspaceCapabilityConfiguration = {
    otpDelivery: CustomerAuthenticationOtpDeliveryConfiguration | null;
    /**
     * Number of digits in each generated OTP. Allowed range is 4–8.
     */
    otpLength: number;
    otpExpiryWindowMinutes: number;
    sessionExpiryMinutes: number;
};

const customerAuthenticationOtpSmsDeliveryConfigurationValidator: zod.ZodType<CustomerAuthenticationOtpSmsDeliveryConfiguration> = zod.strictObject({
    apiUrl: zod.string().url(),
    from: zod.string().min(1),
    messageTemplate: zod.string().min(1),
    password: zod.string().min(1),
    smsType: zod.string().min(1),
    templateId: zod.string().min(1),
    username: zod.string().min(1),
});

const customerAuthenticationOtpDeliveryConfigurationValidator: zod.ZodType<CustomerAuthenticationOtpDeliveryConfiguration> = zod.strictObject({
    sms: customerAuthenticationOtpSmsDeliveryConfigurationValidator,
});

export const customerAuthenticationWorkspaceCapabilityConfigurationValidator: zod.ZodType<CustomerAuthenticationWorkspaceCapabilityConfiguration> = zod.strictObject({
    otpDelivery: customerAuthenticationOtpDeliveryConfigurationValidator.nullable(),
    otpLength: zod.number().int().min(1),
    otpExpiryWindowMinutes: zod.number().int().positive(),
    sessionExpiryMinutes: zod.number().int().positive(),
});
